import React from 'react';
import Box from '@mui/material/Box';

export default function Containers({children, mainStyle}) {
    return (
        <Box sx={[{display: 'grid', gridTemplateRows: '1fr', rowGap: '80px'}, mainStyle ? mainStyle : {}]}>
            {children}
        </Box>
    )
}